import { addCacheBuster } from 'util/addCacheBuster';
import { useCallback } from 'react';
import { ResourceRef } from 'api/types';
import { decryptFile } from 'toolkit/gostEncript/lib/kuznechik';

export const useEncryption = () => {
    const encryptWithExternalKey = useCallback(async (encryptionKey: string, data: ArrayBuffer) => {
        return decryptFile(encryptionKey, data);
    }, []);

    const getAndEncryptImage = useCallback(async (imageResourceRef?: ResourceRef) => {
        try {
            if (!imageResourceRef?.url || !imageResourceRef?.key) {
                console.error(`Wrong data for encrypting avatar ${imageResourceRef?.url}`);
                return '';
            }

            const avatarUrl = imageResourceRef.url;
            const encryptionKey = imageResourceRef.key;

            // download user avatar
            const imageQuery = await fetch(addCacheBuster(avatarUrl));
            const imageData = await imageQuery.arrayBuffer();

            // encrypt image
            const encryptedData = await encryptWithExternalKey(encryptionKey, imageData);

            const data = new Uint8Array(encryptedData).reduce((data, byte) => {
                return data + String.fromCharCode(byte);
            }, '');
            const base64String = btoa(data);
            const imageString = 'data:image/jpg;base64,' + base64String;

            return imageString;
        } catch (e) {
            throw e;
        }
    }, []);

    return {
        encryptWithExternalKey,
        getAndEncryptImage,
    };
};
